// src/components/YourModule/GoodsReceiptModule/AllGoodsReceipts.jsx

import React, { useCallback, useEffect, useState, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import {
  Search,
  Plus,
  // Trash2,
  ChevronDown,
  ChevronRight,
  FileText,
  // Package,
  Calendar,
  // User,
  // AlertCircle,
  // Truck,
  // CheckCircle,
  Eye,
  MapPin,
  RefreshCw, // ✅ Added for Sync button
  Hash,
  Package,
  History,
} from "lucide-react";

import Loader from "../../../loader/Loader";
import Pagination from "../../Pagination";
import AddGoodsReceipt from "./AddGoodsReceipt";
import SerialNumberModal from "./SerialNumberModal";
import { domain, domainAccounting } from "../../../../security"; // ✅ domainAccounting imported
import { useSelector } from "react-redux";
// 1. Import selectLocationId
import {
  selectFullName,
  selectLocationId,
  selectUserID
} from "../../../../redux/IchthusSlice";

// const MobileGRCard = ({ gr, expanded, onToggle, onDelete, onViewSerials }) => {
//   return (
//     <div className="bg-white p-4 rounded-lg shadow-sm border border-slate-200 mb-4">
//       <div
//         className="flex justify-between items-start cursor-pointer"
//         onClick={() => onToggle(gr.id)}
//       >
//         <div className="flex gap-3">
//           <div className="mt-1 text-indigo-600">
//             {expanded ? <ChevronDown size={20} /> : <ChevronRight size={20} />}
//           </div>
//           <div>
//             <div className="flex items-center gap-2">
//               <span className="font-bold text-slate-800">
//                 {gr.receiptNumber}
//               </span>
//             </div>
//             <p className="text-sm text-slate-500 flex items-center gap-1 mt-1">
//               <Truck size={14} /> PO: {gr.poNumber || "N/A"}
//             </p>
//             {/* Added Location to Mobile Header */}
//             <p className="text-xs text-indigo-600 flex items-center gap-1 mt-1 font-medium">
//               <MapPin size={12} /> {gr.locationName || "No Location"}
//             </p>
//           </div>
//         </div>
//         <div className="text-right">
//           <span className="px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 border border-emerald-200">
//             Completed
//           </span>
//           <p className="text-[10px] text-slate-400 mt-2">
//             {new Date(gr.receiptDate).toLocaleDateString()}
//           </p>
//         </div>
//       </div>

//       {expanded && (
//         <div className="mt-4 pt-4 border-t border-slate-100">
//           <div className="mb-4 bg-slate-50 p-2 rounded border border-slate-100 text-xs text-slate-600">
//             <div className="flex items-center gap-2">
//               <User size={14} className="text-slate-400" />
//               <span>
//                 Received By: <strong>{gr.receivedBy}</strong>
//               </span>
//             </div>
//           </div>

//           <h4 className="font-semibold text-slate-700 mb-2 text-sm flex items-center gap-2">
//             <Package size={16} /> Received Items
//           </h4>
//           <div className="space-y-3">
//             {gr.goodsReceiptLines && gr.goodsReceiptLines.length > 0 ? (
//               gr.goodsReceiptLines.map((item) => {
//                 const serialsToDisplay =
//                   item.receiptSerialNumbers || item.serialNumbers || [];
//                 const productName =
//                   item.product?.productName ||
//                   item.productName ||
//                   "Unknown Item";
//                 return (
//                   <div
//                     key={item.id}
//                     className="bg-slate-50 p-3 rounded text-sm border border-slate-200"
//                   >
//                     <div className="flex justify-between items-center mb-1">
//                       <span className="font-medium text-slate-700">
//                         {productName}
//                       </span>
//                       <span className="font-bold text-indigo-600">
//                         Qty: {item.quantityReceived}
//                       </span>
//                     </div>
//                     {serialsToDisplay.length > 0 && (
//                       <button
//                         onClick={() =>
//                           onViewSerials(serialsToDisplay, productName)
//                         }
//                         className="mt-2 w-full py-1.5 px-3 bg-white border border-indigo-200 text-indigo-600 rounded text-xs font-medium flex items-center justify-center gap-2"
//                       >
//                         <Eye size={12} /> View {serialsToDisplay.length} Serials
//                       </button>
//                     )}
//                   </div>
//                 );
//               })
//             ) : (
//               <p className="text-xs text-slate-400 italic">No lines found.</p>
//             )}
//           </div>

//           <button
//             onClick={() => onDelete(gr.id)}
//             className="w-full mt-4 py-2 bg-red-50 text-red-600 rounded text-xs font-medium border border-red-200 flex items-center justify-center gap-2"
//           >
//             <Trash2 size={14} /> Delete Receipt
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

const formatCurrency = (amount, currency = "PHP") => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "PHP",
    minimumFractionDigits: 2,
  }).format(amount || 0);
};

const AllGoodsReceipts = () => {
  const currentUserId = useSelector(selectUserID); // ✅ ADDED
  const fullName = useSelector(selectFullName);
  // 2. Get User Location ID from Redux
  const userLocationId = useSelector(selectLocationId);

  const [grData, setGrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedGR, setExpandedGR] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Default state is "my"
  const [activeTab, setActiveTab] = useState("my");

  // Location States
  const [selectedLocation, setSelectedLocation] = useState("");
  // 3. State for Master Location List
  const [allLocationsList, setAllLocationsList] = useState([]);

  // ✅ Sync state
  const [isSyncing, setIsSyncing] = useState(false);

  const [serialModalData, setSerialModalData] = useState({
    isOpen: false,
    serials: [],
    productName: "",
  });

  // 4. Extract Unique Locations from MASTER LIST, put "All" at bottom
  const locations = useMemo(() => {
    if (allLocationsList.length === 0) return ["All"];

    // Extract names and sort alphabetically
    const locNames = allLocationsList.map((l) => l.locationName).sort();
    const uniqueNames = [...new Set(locNames)];

    // Place "All" at the BOTTOM
    return [...uniqueNames, "All"];
  }, [allLocationsList]);

  // 5. Auto-select Default Location based on Redux User Location ID
  useEffect(() => {
    if (allLocationsList.length > 0 && selectedLocation === "") {
      if (userLocationId) {
        // Match the ID to the Name from the master list
        const userLoc = allLocationsList.find(
          (l) => l.id === parseInt(userLocationId),
        );
        if (userLoc) {
          setSelectedLocation(userLoc.locationName);
        } else {
          setSelectedLocation("All");
        }
      } else {
        setSelectedLocation("All");
      }
    }
  }, [allLocationsList, userLocationId, selectedLocation]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // 6. Fetch GRs AND Locations
      const [response, locResponse] = await Promise.all([
        axios.get(`${domain}/api/GoodsReceiptMain`),
        axios.get(`${domain}/api/Locations`),
      ]);

      setAllLocationsList(locResponse.data);

      const sortedData = response.data.sort(
        (a, b) => new Date(b.receiptDate) - new Date(a.receiptDate),
      );

      const normalizedData = sortedData.map((gr) => ({
        ...gr,
        goodsReceiptLines: (gr.lines || gr.goodsReceiptLines || []).map(
          (line) => ({
            ...line,
            receiptSerialNumbers: line.receiptSerialNumbers || [],
            serialNumbers: line.serialNumbers || [],
            productName: line.product
              ? line.product.productName
              : line.productName,
          }),
        ),
      }));

      setGrData(normalizedData);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch goods receipts.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // const deleteGoodsReceipt = async (id) => {
  //   if (
  //     !window.confirm(
  //       "Are you sure you want to delete this Goods Receipt? \n\nThis will reverse the inventory stock.",
  //     )
  //   )
  //     return;
  //   try {
  //     await axios.delete(`${domain}/api/GoodsReceipts/${id}`);
  //     toast.success("Goods Receipt deleted successfully.");
  //     if (expandedGR === id) setExpandedGR(null);
  //     fetchData();
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || "Failed to delete receipt.");
  //   }
  // };

  // ✅ Sync to Accounting — POST to domainAccounting /api/GoodReceipt/bulk
  const syncToAccounting = async () => {
    if (filteredGRs.length === 0) {
      toast.warning("No receipts to sync.");
      return;
    }

    const confirmed = window.confirm(
      `Sync ${filteredGRs.length} goods receipt(s) to accounting?\n\nThis will post the entries to your accounting system.`,
    );
    if (!confirmed) return;

    setIsSyncing(true);
    try {
      // ✅ Payload matches POST /api/GoodReceipt/bulk schema exactly — plain array
      const payload = filteredGRs.map((gr) => ({
        grNumber: gr.receiptNumber ?? "",
        manualGRNumber: gr.manualGrNumber ?? "",
        purchaseOrderPONumber: gr.poNumber ?? "",
        amount: gr.totalAmount ?? 0,
        grDate: gr.receiptDate
          ? new Date(gr.receiptDate).toISOString()
          : new Date().toISOString(),
        uploadedFile: gr.uploadedFile ?? "",
        notes: gr.notes ?? "",
        status: gr.status ?? "Completed",
        createdDate: gr.createdDate
          ? new Date(gr.createdDate).toISOString()
          : new Date().toISOString(),
        createdBy: gr.createdBy ?? 0,
        goodReceiptDetails: (gr.goodsReceiptLines || []).map((line) => ({
          id: line.id ?? 0,
          goodsReceiptHeaderId: gr.id ?? 0,
          itemCode: line.itemCode ?? line.product?.itemCode ?? "",
          orderedQty: line.quantityOrdered ?? line.quantityReceived ?? 0,
          receivedQty: line.quantityReceived ?? 0,
          remainingQty:
            (line.quantityOrdered ?? line.quantityReceived ?? 0) -
            (line.quantityReceived ?? 0),
          unitPrice: line.unitPrice ?? 0,
          subTotal: line.subTotal ?? 0,
          taxationCodeId: line.taxationCodeId ?? 0,
          totalDiscount: line.totalDiscount ?? 0,
          taxAmount: line.taxAmount ?? 0,
          totalAmount: line.totalAmount ?? 0,
        })),
      }));

      console.log("=== SYNC TO ACCOUNTING PAYLOAD ===");
      console.log("Total GRs to sync:", payload.length);
      payload.forEach((gr, i) => {
        console.log(`\n--- GR [${i}] ---`);
        console.log("grNumber:", gr.grNumber);
        console.log("purchaseOrderId:", gr.purchaseOrderId);
        console.log("amount:", gr.amount);
        console.log("grDate:", gr.grDate);
        console.log("uploadedFile:", gr.uploadedFile);
        console.log("notes:", gr.notes);
        console.log("status:", gr.status);
        console.log("createdDate:", gr.createdDate);
        console.log("createdBy:", gr.createdBy);
        console.log("goodReceiptDetails:", gr.goodReceiptDetails);
      });
      console.log("\n=== FULL PAYLOAD (JSON) ===");
      console.log(JSON.stringify(payload, null, 2));

      await axios.post(`${domainAccounting}/api/GoodReceipt/bulk`, payload);

      toast.success(
        `Successfully synced ${filteredGRs.length} receipt(s) to accounting.`,
      );
    } catch (error) {
      console.error("Sync error:", error);
      toast.error(
        error.response?.data?.message ||
          `Sync failed (${error.response?.status ?? "unknown error"}). Please try again.`,
      );
    } finally {
      setIsSyncing(false);
    }
  };

  const openSerialModal = (serials, productName) => {
    setSerialModalData({
      isOpen: true,
      serials: serials,
      productName: productName,
    });
  };

  const closeSerialModal = () => {
    setSerialModalData((prev) => ({ ...prev, isOpen: false }));
  };

  const tabFilteredGRs = grData.filter((gr) => {
    if (activeTab === "my")
      return gr.receivedBy?.toLowerCase() === fullName?.toLowerCase();
    return true;
  });

  // Updated Filtering Logic
  const filteredGRs = tabFilteredGRs.filter((gr) => {
    const matchesSearch =
      (gr.receiptNumber?.toLowerCase() || "").includes(
        searchTerm.toLowerCase(),
      ) ||
      (gr.poNumber?.toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (gr.receivedBy?.toLowerCase() || "").includes(searchTerm.toLowerCase());

    const matchesLocation =
      selectedLocation === "All" ||
      gr.locationName === selectedLocation ||
      selectedLocation === "";

    return matchesSearch && matchesLocation;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentGRs = filteredGRs.slice(indexOfFirstItem, indexOfLastItem);

  const [selectedGR, setSelectedGR] = useState(null);

  const fetchDataGRById = useCallback(async (id) => {
    try {
      const response = await axios.get(`${domain}/api/GoodsReceiptMain/${id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const openModal = () => setIsModalVisible(true);
  const closeModal = () => setIsModalVisible(false);
  const toggleExpandGR = async (id) => {
    setLoading(true)
    let _selectedGR = null
    if(expandedGR !== id)
    {
      _selectedGR = await fetchDataGRById(id)
    }
    setSelectedGR(_selectedGR)

    setExpandedGR(expandedGR === id ? null : id)
    setLoading(false)
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  const [showSyncToAccountingForm, setShowSyncToAccountingForm] = useState(false);
  const openSyncToAccountingForm = () => {
    setShowSyncToAccountingForm(true);
  }
  const closeSyncToAccountingForm = () => {
    setShowSyncToAccountingForm(false);
  }

  const handleSyncToAccounting = async (dateFrom, dateTo) => {
    if(grData.length <= 0){
      toast.error(`No data to Sync.`);
      return
    }

    setLoading(true)

    try {
      const getDateOnly = value => {
        const d = new Date(value);
        d.setHours(0, 0, 0, 0);
        return d.getTime();
      };

      const filtered = grData.filter(i => {
        const date = getDateOnly(i.receiptDate);
        const from = getDateOnly(dateFrom);
        const to = getDateOnly(dateTo);

        return date >= from && date <= to;
      });

      // const finalData = filtered?.filter(i => i.receiptDate >= dateFrom && i.receiptDate <= dateTo).map(gr => {
      const finalData = filtered?.map(gr => {
        const amount = (gr.poReference || []).reduce((poSum, po) => {
            return poSum + (po.purchaseOrderLineItem || []).reduce((lineSum, line) => {
              return lineSum + ((Number(line.unitPrice) || 0) * (Number(line.receivedQuantity) || 0));
            }, 0);
          }, 0);

        return {
          goodReceiptDetails: gr.poReference?.map((item) => ({
            purchaseOrderPONumber: item.poNumber,

            goodReceiptDetailLines: item.purchaseOrderLineItem?.map((line) => ({
              itemCode: line.itemCode,
              orderedQty: line.quantity,
              receivedQty: line.receivedQuantity,
              remainingQty: line.remainingQuantity ?? 0,
              unitPrice: line.unitPrice,
              subTotal: line?.subTotal,
              taxationCodeId: 0,
              totalDiscount: line?.totalDiscount,
              taxAmount: line?.taxAmount,
              totalAmount: line?.totalAmount
            }))
          })),

          grNumber: gr.receiptNumber ?? "", 
          manualGRNumber: gr.manualGrNumber ?? null,
          vendorId: gr.vendorCode ?? "",
          amount: amount,
          grDate: gr.receiptDate,
          uploadedFile: "",
          notes: gr?.notes,
          //status: gr.status,
          createdDate: new Date().toISOString(),
          createdBy: currentUserId || 0,
        }
      });

      console.log({finalData})

      await axios.post(
        `${domainAccounting}/api/GoodReceipt/bulk`,
        finalData,
      );

      toast.success(
        `Successfully pushed ${grData?.length || 0 } to Accounting!`,
      );

    } catch (error) {
      console.error(error);
      toast.error(`Failed to push "order"} to Accounting.`);
    } finally {
      setLoading(false)
    }
  };

  return (
    <div className="min-h-screen pb-12">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="bg-white border-slate-200 sticky top-0 z-20 shadow-sm">
        <div className="max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                <FileText className="text-indigo-600" /> Goods Receipts
              </h1>
              <p className="text-sm text-slate-500 mt-1">
                Track received inventory, serial numbers, and PO fulfillment.
              </p>
            </div>

            {/* ✅ Button Group: Sync to Accounting + New Receipt */}
            <div className="flex items-center gap-3">
              <button
                onClick={syncToAccounting}
                disabled={isSyncing}
                className={`hidden items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-lg border transition-all
                  ${
                    isSyncing
                      ? "bg-emerald-50 text-emerald-400 border-emerald-200 cursor-not-allowed"
                      : "bg-white text-emerald-700 border-emerald-500 hover:bg-emerald-50 shadow-sm"
                  }`}
              >
                <RefreshCw
                  size={16}
                  className={isSyncing ? "animate-spin" : ""}
                />
                {isSyncing ? "Syncing..." : "Sync to Accounting"}
              </button>

              <button
                onClick={() => openSyncToAccountingForm()}
                className="flex items-center gap-2 px-3.5 py-2 bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 rounded-xl text-sm font-medium transition"
              >
                <History size={16} />
                <span className="hidden sm:inline">Sync To Accounting</span>
              </button>

              <button
                onClick={openModal}
                className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg shadow-sm transition-all"
              >
                <Plus size={18} /> New Receipt
              </button>
            </div>
          </div>

          <div className="flex gap-6 mt-6 border-b border-slate-200">
            <button
              onClick={() => handleTabChange("my")}
              className={`pb-3 text-sm font-medium transition-all relative ${activeTab === "my" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500 hover:text-slate-700"}`}
            >
              My Receipts
            </button>
            <button
              onClick={() => handleTabChange("all")}
              className={`pb-3 text-sm font-medium transition-all relative ${activeTab === "all" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500 hover:text-slate-700"}`}
            >
              All Receipts
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200 mb-6">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input
                type="text"
                placeholder="Search by Receipt #, PO #, or Receiver..."
                className="w-full pl-9 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 transition-shadow text-sm"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            {/* Location Dropdown UI */}
            <div className="relative min-w-[220px]">
              <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <select
                value={selectedLocation}
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                  setCurrentPage(1);
                }}
                className="w-full pl-9 pr-10 py-2 border border-slate-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 appearance-none bg-white text-sm text-slate-700 cursor-pointer transition-shadow"
              >
                {locations.map((loc) => (
                  <option key={loc} value={loc}>
                    {loc === "All" ? "All Locations" : loc}
                  </option>
                ))}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                <ChevronDown size={16} />
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <Loader />
          </div>
        ) : (
          <>
            <div className="hidden md:block bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <table className="w-full text-sm text-left text-slate-600">
                <thead className="text-xs text-slate-500 uppercase bg-slate-50 border-b border-slate-200">
                  <tr>
                    <th className="w-10 px-4 py-4"></th>
                    <th className="px-4 py-4">Manual GR No</th> {/* Added Column */}
                    <th className="px-4 py-4">Receipt #</th>
                    {/* <th className="px-4 py-4">Location</th> */}
                    <th className="px-4 py-4">PO Reference</th>
                    <th className="px-4 py-4">Date Received</th>
                    <th className="px-4 py-4">Received By</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {currentGRs.map((gr) => (
                    <React.Fragment key={gr.id}>
                      <tr
                        onClick={() => toggleExpandGR(gr.id)}
                        className={`hover:bg-slate-50 transition cursor-pointer ${expandedGR === gr.id ? "bg-slate-50" : ""}`}
                      >
                        <td className="px-4 py-4 text-center">
                          {expandedGR === gr.id ? (
                            <ChevronDown size={16} />
                          ) : (
                            <ChevronRight size={16} />
                          )}
                        </td>
                        <td className="px-4 py-4 font-semibold text-slate-800">
                          {gr.manualGrNumber || "N/A"}
                        </td>
                        <td className="px-4 py-4 font-semibold text-slate-800">
                          {gr.receiptNumber}
                        </td>
                        {/* Location Cell */}
                        {/* <td className="px-4 py-4">
                          <span className="flex items-center gap-1.5 text-indigo-600 font-medium">
                            <MapPin size={14} /> {gr.locationName || "N/A"}
                          </span>
                        </td> */}
                        <td className="px-4 py-4">
                          <div className="flex flex-col gap-4">
                            {gr.poReference.map((item, index) => (
                              <div key={index} className="group flex flex-col">
                                {/* PO Number Line */}
                                <div className="flex items-center gap-2 text-sm font-bold text-slate-800">
                                  <FileText size={14} className="text-indigo-500" />
                                  <span>{item?.poNumber}</span>
                                </div>
                                
                                {/* Location Line */}
                                <div className="flex items-center gap-1.5 text-xs text-slate-500 mt-0.5">
                                  <MapPin size={12} className="text-slate-400" />
                                  <span className="truncate max-w-[150px]">{item.locationName}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex items-center gap-2">
                            <Calendar size={14} className="text-slate-400" />
                            {new Date(gr.receiptDate).toLocaleDateString()}
                          </div>
                        </td>
                        <td className="px-4 py-4">{gr.receivedBy}</td>
                        {/* <td className="px-4 py-4">
                          <div
                            className="flex items-center justify-center"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              onClick={() => deleteGoodsReceipt(gr.id)}
                              className="p-1.5 text-red-600 hover:bg-red-50 rounded transition"
                            >
                              <Trash2 size={18} />
                            </button>
                          </div>
                        </td> */}
                      </tr>

                      {selectedGR && expandedGR === gr.id && (
                        <tr>
                          <td
                            colSpan="7"
                            className="bg-slate-50 p-4 border-b border-slate-200 shadow-inner"
                          >
                            <div className="bg-white rounded border border-slate-200 p-4">
                              <div className="hidden justify-between items-center mb-4 pb-2 border-b border-slate-100">
                                <div className="flex gap-4">
                                  <div className="text-xs">
                                    <span className="text-slate-400 uppercase font-bold block">
                                      Location
                                    </span>
                                    <span className="font-semibold">
                                      {gr.locationName || "N/A"}
                                    </span>
                                  </div>
                                  <div className="text-xs">
                                    <span className="text-slate-400 uppercase font-bold block">
                                      PO Number
                                    </span>
                                    <span className="font-semibold">
                                      {gr.poNumber || "N/A"}
                                    </span>
                                  </div>
                                </div>
                                {gr.notes && (
                                  <span className="text-xs text-slate-500 italic bg-yellow-50 px-2 py-1 rounded border border-yellow-100">
                                    Note: {gr.notes}
                                  </span>
                                )}
                              </div>

                              <div className="overflow-hidden rounded-xl border border-slate-200 shadow-sm bg-white">
                                <table className="w-full text-xs text-left">
                                  {/* Clean Header - Reduced to 3 Columns for better focus */}
                                  <thead className="bg-slate-50 text-slate-500 uppercase tracking-wider font-bold border-b border-slate-200">
                                    <tr>
                                      <th className="px-6 py-3 w-1/2">Product Details</th>
                                      <th className="px-6 py-3 text-center">Unit Price</th>
                                      <th className="px-6 py-3 text-center">Qty Received</th>
                                      <th className="px-6 py-3 text-center">Total Amount</th>
                                      <th className="px-6 py-3 text-right">Verification</th>
                                    </tr>
                                  </thead>

                                  <tbody className="divide-y divide-slate-100">
                                    {selectedGR?.poReference?.map((po, poIdx) => (
                                      <React.Fragment key={po.id || poIdx}>
                                        {/* PO Group Header Row - Distinct styling */}
                                        <tr className="bg-indigo-50/50 border-y border-indigo-100">
                                          <td colSpan="5" className="px-4 py-2.5">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-5">
                                                <div className="flex items-center gap-1.5 px-2 py-1 bg-white border border-indigo-200 rounded shadow-sm text-indigo-700 font-bold">
                                                  <Hash size={12} />
                                                  {po.poNumber}
                                                </div>
                                                <div className="flex items-center gap-1.5 text-slate-600 font-medium">
                                                  <MapPin size={14} className="text-slate-400" />
                                                  {po.locationName}
                                                </div>
                                              </div>
                                              <div className="text-[10px] bg-indigo-100 text-indigo-600 px-2 py-0.5 rounded-full font-bold uppercase">
                                                {po.purchaseOrderLineItem?.length || 0} Items Included
                                              </div>
                                            </div>
                                          </td>
                                        </tr>

                                        {/* PO Line Items */}
                                        {po.purchaseOrderLineItem?.map((line, lineIdx) => {
                                          const serials = line.receiptSerialNumbers || line.serialNumbers || [];

                                          const totalAmount = line.quantity * line.unitPrice;
                                          return (
                                            <tr
                                              key={`${po.id}-${line.id || lineIdx}`}
                                              className="group hover:bg-slate-50/80 transition-colors"
                                            >
                                              {/* Product Column */}
                                              <td className="px-6 py-4">
                                                <div className="flex items-start gap-3">
                                                  <div className="mt-1 p-2 bg-slate-100 rounded-lg text-slate-400 group-hover:bg-white group-hover:text-indigo-500 transition-all border border-transparent group-hover:border-slate-200">
                                                    <Package size={16} />
                                                  </div>
                                                  <div className="flex flex-col">
                                                    <span className="text-sm font-bold text-slate-700 leading-tight">
                                                      {line.productName}
                                                    </span>
                                                    <span className="text-[11px] text-slate-400 mt-0.5 flex items-center gap-1">
                                                      <span className="font-mono bg-slate-50 px-1 rounded border border-slate-100">
                                                        ID: {line.productId || 'N/A'}
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </td>

                                              {/* Quantity Column */}
                                              <td className="px-6 py-4 text-center">
                                                <span className="text-lg font-black text-slate-800 tabular-nums">
                                                  {formatCurrency(line.unitPrice, po.currency)}
                                                </span>
                                              </td>

                                              {/* Quantity Column */}
                                              <td className="px-6 py-4 text-center">
                                                <div className="inline-flex flex-col items-center">
                                                  <span className="text-lg font-black text-slate-800 tabular-nums">
                                                    {line.receivedQuantity}
                                                  </span>
                                                  <span className="text-[9px] text-slate-400 uppercase font-bold tracking-tighter">
                                                    Units Received
                                                  </span>
                                                </div>
                                              </td>

                                              {/* Quantity Column */}
                                              <td className="px-6 py-4 text-center">
                                                <span className="text-lg font-black text-slate-800 tabular-nums">
                                                  {formatCurrency(totalAmount, po.currency)}
                                                </span>
                                              </td>

                                              {/* Serials Column */}
                                              <td className="px-6 py-4 text-right">
                                                {serials.length > 0 ? (
                                                  <button
                                                    type="button"
                                                    onClick={() => openSerialModal(serials, line.productName)}
                                                    className="inline-flex items-center gap-2 px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-700 hover:border-indigo-500 hover:text-indigo-600 hover:shadow-md hover:shadow-indigo-50 transition-all group/btn"
                                                  >
                                                    <Eye size={14} className="text-slate-400 group-hover/btn:text-indigo-500" />
                                                    <span>View Serials</span>
                                                    <span className="ml-1 bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded text-[10px]">
                                                      {serials.length}
                                                    </span>
                                                  </button>
                                                ) : (
                                                  <span className="inline-block px-2 py-1 rounded bg-slate-50 text-slate-300 text-[10px] font-medium uppercase tracking-widest">
                                                    Standard Item
                                                  </span>
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </React.Fragment>
                                    ))}

                                    {(!selectedGR?.poReference || selectedGR.poReference.length === 0) && (
                                      <tr>
                                        <td colSpan="3" className="px-6 py-16 text-center">
                                          <div className="flex flex-col items-center gap-2">
                                            <Package size={40} className="text-slate-200" />
                                            <p className="text-slate-400 text-sm italic">No items found in this receipt.</p>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>

            {/* <div className="md:hidden">
              {currentGRs.map((gr) => (
                <MobileGRCard
                  key={gr.id}
                  gr={gr}
                  expanded={expandedGR === gr.id}
                  onToggle={toggleExpandGR}
                  onDelete={deleteGoodsReceipt}
                  onViewSerials={openSerialModal}
                />
              ))}
            </div> */}

            <div className="mt-6">
              <Pagination
                itemsPerPage={itemsPerPage}
                totalItems={filteredGRs.length}
                currentPage={currentPage}
                paginate={paginate}
              />
            </div>
          </>
        )}
      </div>

      {isModalVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
          <div className="w-full max-w-6xl max-h-[95vh] overflow-hidden">
            <AddGoodsReceipt onClose={closeModal} refreshData={fetchData} />
          </div>
        </div>
      )}

      <SerialNumberModal
        isOpen={serialModalData.isOpen}
        onClose={closeSerialModal}
        serialNumbers={serialModalData.serials}
        productName={serialModalData.productName}
      />

      <SyncToAccountingModal 
        isOpen={showSyncToAccountingForm}
        onClose={closeSyncToAccountingForm}
        onConfirm={handleSyncToAccounting}
      />
    </div>
  );
};

const SyncToAccountingModal = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(today);
  const [dateTo, setDateTo] = useState(today);

  if (!isOpen) return null;

  const handleSubmit = () => {
    onConfirm(dateFrom, dateTo);
    onClose();
  };
  
  const inputClass =
    "block w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm font-semibold text-gray-900 transition-all focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 outline-none";
  const labelClass =
    "mb-1 ml-0.5 block text-[10px] font-black uppercase tracking-widest text-gray-500";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all scale-100">
        {/* Header */}
        <div className="bg-indigo-600 px-6 py-4 flex justify-between items-center">
          <h2 className="text-white text-lg font-bold flex items-center gap-2">
            Sync To Accounting
          </h2>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-600 mb-4">
            You are about to sync data to accounting.
            <br />
            <br />
            <strong>Please fill up fields to filter data</strong>
          </p>

          <div className="flex flex-col gap-3">
            <div>
              <label className={labelClass}>
                Order Date From
                <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                className={`${inputClass} !border-indigo-300`}
              />
            </div>
            <div>
              <label className={labelClass}>
                Order Date To
                <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                className={`${inputClass} !border-indigo-300`}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 shadow-md"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllGoodsReceipts;
